<template
  ><div
    :style="{
      height: `${connectorHeight}px`,
      margin: `-${elementHalfHeight}px 0`
    }"
    class="v-field-connector"
  ></div
></template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VFieldConnector", {
  props: {
    ids: VueTypes.array
  },

  data() {
    return {
      connectorHeight: null,
      topElement: null,
      elementHalfHeight: null
    };
  },

  methods: {
    _getElementById(element) {
      return document.getElementById(element);
    },

    _getElementCenter(domElement) {
      return (
        (domElement.getBoundingClientRect().bottom -
          domElement.getBoundingClientRect().top) /
        2
      );
    },

    _getElementCoordinates(domElement) {
      return (
        domElement.getBoundingClientRect().top +
        this._getElementCenter(domElement)
      );
    },

    getDistanceFromTop(id) {
      const getElement = this._getElementById(id);
      return this._getElementCoordinates(getElement);
    },

    getConnectorHeight(idFirstElement, idSecondElement) {
      const distanceTopFirst = this.getDistanceFromTop(idFirstElement);
      const distanceTopSecond = this.getDistanceFromTop(idSecondElement);
      if (distanceTopFirst > distanceTopSecond) {
        this.topElement = idSecondElement;
        return distanceTopFirst - distanceTopSecond;
      }
      this.topElement = idFirstElement;
      return distanceTopSecond - distanceTopFirst + 2;
    }
  },

  mounted() {
    this.connectorHeight = Math.round(
      this.getConnectorHeight(this.ids[0], this.ids[1])
    );
    this.elementHalfHeight = Math.round(
      this._getElementCenter(this._getElementById(this.topElement))
    );
  }
});
</script>

<style>
.v-field-connector {
  position: absolute;
  left: -20px;
  width: 14px;
  border: 2px solid rgba(87, 87, 245, 0.5);
  border-radius: 5px 0 0 5px;
  border-right: none;
}
</style>
